import React, { useEffect, useState } from "react";
import Chart from 'react-apexcharts';
import '../../cssfiles/homepage.css';

const semicirculargauge = {
    chart: {
      type: 'radialBar',
      offsetY: -20,
      sparkline: {
        enabled: true
      }
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: "#e7e7e7",
          strokeWidth: '97%',
          margin: 5, // margin is in pixels
          dropShadow: {
            enabled: true,
            top: 2,
            left: 0,
            color: '#999',
            opacity: 1,
            blur: 2
          }
        },
        dataLabels: {
          name: {
            show: false
          },
          value: {
            offsetY: -2,
            fontSize: '22px'
          }
        }
      }
    },
    grid: {
      padding: {
        top: -10
      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        shadeIntensity: 0.4,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 53, 91]
      },
    },
    labels: ['Average Results'],
}

export default function Semicirculargaugecard (props) {
    const [tagporpslist, setTagpropslist] = useState([])
    const [editorseries, setEditorseries] = useState([70])
    const [chartoptions, setChartoption] = useState(semicirculargauge)

    useEffect(() => {
        if(props.extendedprops !== undefined) {
            if(props.extendedprops.hasOwnProperty("tagpropslist")) {
                setTagpropslist(props.extendedprops.tagpropslist)
                var seriesdata = []
                for(let i=0; i<props.extendedprops.tagpropslist.length; i++) {
                    seriesdata.push(70)
                }
                setChartoption(semicirculargauge)
                setEditorseries(seriesdata)
            }
        }
        //console.log("tagporpslist ",props.extendedprops.tagpropslist)
    },[props.extendedprops])


    return(
        <div style={{height: 'calc(100% - 5px)', width: 'calc(100% - 5px)',  overflow: 'auto'}}>
            <Chart options={chartoptions} series={editorseries} type='radialBar' width={"100%"}/>
        </div>
        
    )
}